import { Avatar, Center, Menu, Text, useMantineTheme } from '@mantine/core';
import { useProfile } from 'init/use-enforce-profile';
import { i18nKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';
import { doesLocationBelongToPath } from 'modules/Navigation/utils';
import type { MouseEvent } from 'react';
import { useHistory, useLocation } from 'react-router';
import { GROUP_OVERVIEW_FEATURE_FLAG, GROUP_ROUTE } from 'shared/constants';
import apiService from 'shared/service/api.service';
import { useIsFeatureFlagEnabled } from 'shared/utils/feature-flags';

const DASHBOARD_PATH = '/dashboard';

export const TenantSwitcher = () => {
  const { t } = useTranslation();
  const profile = useProfile();
  const theme = useMantineTheme();
  const history = useHistory();
  const { pathname } = useLocation();
  const isInGroup = doesLocationBelongToPath({ locationPath: pathname, path: GROUP_ROUTE });
  const isGroupOverviewEnabled = useIsFeatureFlagEnabled(GROUP_OVERVIEW_FEATURE_FLAG);

  const stayInTheApp = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    history.push(DASHBOARD_PATH);
  };

  const navigationFor = (tenant: { url: string }, isSelected: boolean) =>
    isGroupOverviewEnabled
      ? {
          href: isSelected ? DASHBOARD_PATH : tenant.url,
          onClick: isSelected ? stayInTheApp : undefined,
        }
      : { href: undefined, onClick: () => window.location.assign(tenant.url) };

  return (
    <>
      {profile.accessibleTenants.map(tenant => {
        const isSelected = tenant.subdomain === apiService.tenant;

        return (
          <Menu.Item
            mb="space1"
            key={tenant.id}
            component="a"
            {...navigationFor(tenant, isSelected)}
            leftSection={
              <Avatar radius={6} size={24} src={tenant.logo} name={tenant.companyName} />
            }
            styles={
              isSelected && !isInGroup
                ? { item: { backgroundColor: theme.colors.purple[1] } }
                : undefined
            }
          >
            {isSelected ? (
              <Center inline>
                <Text>{tenant.companyName}</Text>
                <Text ml="space1" c="purple.4">
                  · {t(i18nKeys.NAV.CONNECTED)}
                </Text>
              </Center>
            ) : (
              <Text>{tenant.companyName}</Text>
            )}
          </Menu.Item>
        );
      })}
    </>
  );
};
